import { api } from './apiClient';
import type { SearchResponse, SearchType } from '@/types/search';

export interface SearchParams {
  query: string;
  type?: SearchType;
  page?: number;
  signal?: AbortSignal | null;
}

export const searchApi = {
  search({ query, type = 'multi', page = 1, signal }: SearchParams): Promise<SearchResponse> {
    const qs = new URLSearchParams({ query, type, page: String(page) });
    return api<SearchResponse>(`/api/search?${qs.toString()}`, { auth: true, signal });
  },
};
